module.exports = __webpack_public_path__ + "6c6acf8615168b817137613f53df0ab4.MP3";